export default __webpack_public_path__ + "static/media/mode-531.a28474e1.svg";